import { memo } from "react";

import IconChevron from "@/assets/icons/profile/arrow-right-01-round.svg";

interface ProfileMenuOptionProps {
    icon: React.ReactNode;
    label: string;
    rightContent?: React.ReactNode;
    onClick?: () => void;
    className?: string;
    textColor?: string;
    /** Ẩn chevron mũi tên (VD: nút Logout) */
    hideChevron?: boolean;
}

/**
 * ProfileMenuOption - Figma: Node 2397:22496
 * Layout: row, alignItems: center, gap: 12px, padding: 12px 16px
 * Background: #F9F9FA, borderRadius: 8px
 * Text: Body 2/normal (Be Vietnam Pro 400, 16px, 1.5em) - color #0A0C11
 * Icon size: 24x24px (flex-shrink-0)
 */
export const ProfileMenuOption = memo(
    ({
        icon,
        label,
        rightContent,
        onClick,
        className = "",
        textColor = "text-[#0A0C11]",
        hideChevron = false,
    }: ProfileMenuOptionProps) => {
        return (
            <button
                type="button"
                onClick={onClick}
                className={`w-full flex items-center gap-3 px-4 py-3 bg-[#F9F9FA] rounded-[10px]
                    active:opacity-70 transition-opacity duration-150 text-left ${className}`}
            >
                {/* Icon trái - fixed 24x24 */}
                <span className="flex-shrink-0 w-6 h-6 flex items-center justify-center">
                    {icon}
                </span>

                {/* Label giữa - fill width */}
                <span
                    className={`flex-1 font-['Be_Vietnam_Pro'] font-normal text-base leading-[1.5] ${textColor}`}
                >
                    {label}
                </span>

                {/* Content bên phải */}
                {rightContent && (
                    <span className="text-sm text-[#667085] ml-auto">
                        {rightContent}
                    </span>
                )}

                {/* Chevron phải */}
                {!hideChevron && (
                    <img src={IconChevron} alt="Arrow right" className="flex-shrink-0 w-6 h-6 ml-2" />
                )}
            </button>
        );
    },
);

ProfileMenuOption.displayName = "ProfileMenuOption";
